export default __webpack_public_path__ + "static/chart-customisation-af8e514c21fe22f7151dcc43ae6de908.png";